import type { FunctionMeta } from '../function.model';

// =============================================================================
// PARAMS - Mathematical definition
// =============================================================================

/** Absolute value function parameters: a|x-h| + k */
export interface AbsoluteParams {
  /** Vertical scale/reflection (negative flips the V) */
  a: number;
  /** Horizontal shift (vertex x-coordinate) */
  h: number;
  /** Vertical shift (vertex y-coordinate) */
  k: number;
}

// =============================================================================
// META - Function configuration (type-checked)
// =============================================================================

/**
 * Configuration metadata for absolute value functions.
 * Translate behaviors map to h (x) and k (y) parameters.
 */
export const ABSOLUTE_META: FunctionMeta<AbsoluteParams> = {
  availableFeatures: [
    'handle',
    'roots',
    'extrema',
    'tangent',
    'secant',
    'derivative',
    'axisOfSymmetry',
    'intersection',
    'yIntercept',
    'trajectory',
    'monotonicity',
    'functionArea',
    'intersectionArea',
    'domain',
    'range',
  ],
  handleConfigs: {
    translate: { xParam: 'h', yParam: 'k' },
    'translate-x': { xParam: 'h', yParam: 'k' },
    'translate-y': { xParam: 'h', yParam: 'k' },
  },
  defaultParams: {
    a: 1,
    h: 0,
    k: 0,
  },
  defaultRanges: {
    a: [-5, 5],
    h: [-10, 10],
    k: [-10, 10],
  },
};
